import { render, staticRenderFns } from "./CultureNewMediaPostInfo.vue?vue&type=template&id=708a0995&scoped=true&"
import script from "./CultureNewMediaPostInfo.vue?vue&type=script&lang=js&"
export * from "./CultureNewMediaPostInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708a0995",
  null
  
)

export default component.exports